// Persistent (init once)
import SmoothScroll from './SmoothScroll'
import HeaderOnScroll from './HeaderOnScroll'
import PerthTime from '../components/PerthTime'
import Menus from '../components/Menus'

// Per-page (destroyed on navigation, re-created on new page)
import Hero from '../components/Hero'
import Slider from '../components/Slider'
import Video from '../components/Video'
import ProjectGrid from '../components/ProjectGrid'
import Accordions from '../components/Accordions'
import TextAnimation from '../utils/TextAnimation'
import InfiniteSlider from '../components/InfiniteSlider'
import Footer from '../components/Footer'
import Art from '../components/Art'
import InteractiveGoo from '../components/InteractiveGoo'
import ArtworkGallery from '../components/ArtworkGallery'
import ServiceCardHover from '../components/ServiceCardHover'
import ParallaxImage from './ParallaxImage'
import Popup from '../components/Popup'

export default class App {
	constructor() {
		this.pageInstances = []
		this.persistentInstances = []

		this.#initPersistent()
		this.#initPage()
	}

	#initPersistent() {
		this.persistentInstances = [new SmoothScroll(), new Menus(), new HeaderOnScroll(), new Footer()]
	}

	#initPage() {
		this.pageInstances = [
			new Hero(),
			new PerthTime(),
			new Slider(),
			new Video(),
			new ProjectGrid(),
			new Accordions(),
			new InfiniteSlider(),
			new Art(),
			new ParallaxImage(),
			new Popup(),
			new InteractiveGoo(),
			new TextAnimation(),
			new ArtworkGallery(),
			new ServiceCardHover(),
		]
	}

	#destroyPage() {
		this.pageInstances.forEach(instance => instance?.destroy?.())
		this.pageInstances = []
	}

	destroy() {
		this.#destroyPage()
		this.persistentInstances.forEach(instance => instance?.destroy?.())
		this.persistentInstances = []
	}
}
